'use client';
import React from 'react';

export default function HeroSection() {
  return (
    <section
      className="hero-section"
      style={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden'
      }}>

      {/* Background Image */}
      <div
        className="hero-bg"
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'url(/assets/images/hero_real_estate_energetic.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }} />

      {/* Overlay */}
      <div
        className="hero-overlay"
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(45deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%)'
        }} />

      {/* Content */}
      <div
        className="w-full relative z-10"
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '0 24px',
          width: '100%'
        }}>

        <div className="w-full sm:max-w-sm md:max-w-md lg:max-w-lg" style={{ paddingTop: '80px', paddingBottom: '40px' }}>
          <h1
            className="hero-title animate-fade-in-up"
            style={{
              fontSize: 'clamp(28px, 5vw, 54px)',
              lineHeight: 1.1,
              color: '#ffffff',
              fontWeight: 400,
              marginBottom: '20px',
              fontFamily: 'Montserrat, sans-serif'
            }}>
            Homes That{' '}
            <em style={{ fontStyle: 'italic', color: '#6dcff6' }}>build</em>{' '}
            Communities
          </h1>

          <div
            className="animate-fade-in-up animate-delay-100"
            style={{
              marginBottom: '28px',
              opacity: 0
            }}>
            <p
              style={{
                color: 'rgba(255,255,255,0.9)',
                fontSize: 'clamp(14px, 2vw, 16px)',
                lineHeight: 1.7,
                margin: 0,
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 400
              }}>
              For over 50 years, Brickwell Housing has worked to design, develop, and manage residential communities that empower our residents to live more fulfilling lives.
            </p>
          </div>

          <a
            href="/about"
            className="btn-primary animate-fade-in-up animate-delay-200"
            style={{
              backgroundColor: '#003c82',
              color: '#ffffff',
              padding: '12px 24px',
              fontSize: 'clamp(13px, 1.5vw, 14px)',
              fontWeight: '600',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              borderRadius: '2px',
              fontFamily: 'Montserrat, sans-serif',
              opacity: 0
            }}>
            Learn More
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
              <path d="M1 1l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>
      </div>

      {/* Diagonal Cyan Decoration — hidden on very small screens */}
      <div
        className="hero-decoration hidden sm:block"
        style={{
          position: 'absolute',
          bottom: '-2px',
          right: 0,
          width: '45%',
          height: '80px',
          backgroundColor: '#6dcff6',
          clipPath: 'polygon(100% 0, 100% 100%, 0 100%)'
        }} />

    </section>
  );
}